import { InfoIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import { BannerWrapper, IconWrapper } from './TextFrom911Banner.styles';

const NoLocationBanner = () => {
  return (
    <BannerWrapper horizontal>
      <IconWrapper>
        <InfoIcon height="16px" width="16px" />
      </IconWrapper>
      <Text color="background" ml="12px" size="normal">
        No location data available for this number.
      </Text>
    </BannerWrapper>
  );
};

export default NoLocationBanner;
